import React from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'

const AiAssistantButton = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const active = pathname.startsWith('/assistant')

  return (
    <button
      type="button"
      onClick={() => navigate('/assistant')}
      aria-label={t('navigation.assistant')}
      aria-current={active ? 'page' : undefined}
      className={`inline-flex h-10 shrink-0 items-center justify-center rounded-xl px-3 font-display text-sm tracking-[0.12em] transition focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-400 ${
        active
          ? 'bg-white/[0.08] text-white'
          : 'bg-white/[0.04] text-warning hover:bg-white/[0.08] hover:text-white'
      }`}
    >
      AI
    </button>
  )
}

export default AiAssistantButton
